var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loadingGif",attrs:{"src":"https://file.wenms.com/SchoolService/images/loading.gif"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }